import { toast } from 'react-toastify';
import api from './api';
import {
  FILTRO_CONSULTA_PERFIL,
  COLUMNS_CONSULTA_PERFIL,
  FILTRO_CONSULTA_USUARIOS,
  COLUMNS_CONSULTA_USUARIOS,
  FIELDS_CADASTRO_USUARIO,
  COLUMNS_RELATORIO_USUARIOS_BLOQUEIO,
  COLUMNS_RELATORIO_USUARIOS_GESTAO,
  FIELDS_EDITAR_USUARIO,
} from '../constants/mocks';

const getLogUsuario = async (value) => {
  try {
    if (value) {
      const client = await api('mesaveic');
      let { data } = await client.get(
        `/usuario/consultarUsuarios?localizador=${value}`
      );
      if (typeof data === 'string') {
        data = [];
      }
      return data;
    } else {
      return [];
    }
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os Logs.');
    return null;
  }
};

const getColumnsConsultaPerfil = async () => {
  try {
    return COLUMNS_CONSULTA_PERFIL;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas da consulta de perfis.'
    );
    return null;
  }
};

const getFiltersConsultaPerfil = async () => {
  try {
    return FILTRO_CONSULTA_PERFIL;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os filtros da consulta de perfis.'
    );
    return null;
  }
};

const getListConsultaPerfis = async (values) => {
  try {
    if (!values) {
      return [];
    }

    const client = await api('mesaveic');
    const { data } = await client.post(`/perfis/consulta/`, values);

    if (data) {
      return data;
    } else {
      return [];
    }
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os resultados da busca de perfis.'
    );
    return [];
  }
};

const getPermissoesMenu = async (IdGrupo) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/usuario/menu/${IdGrupo}`);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar o perfil.');
    return [];
  }
};

export const getMenus = async () => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/usuario/menu`);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar a lista de menus.');
    return [];
  }
};

const getPermissoesFuncionalidades = async ({ IdMenu, IdGrupo }) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      `/usuario/funcionalidade/${IdMenu}/${IdGrupo}`
    );

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar o perfil.');
    return [];
  }
};

 export const getFuncionalidadesPorMenu = async ({ IdMenu }) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(
      `/usuario/menu/funcionalidade/${IdMenu}`
    );

    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar o perfil.');
    return [];
  }
};

export const getListClintes = async () => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get(
      `/perfis/list/clientes`
    );

    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar a lista de empresas.');
    return [];
  }
}

const salvarPermissoes = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/perfis/permissoes', values);

    return { ...data, success: true };
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar salvar as permissões.');
    return { success: false };
  }
};

const getColumnsConsultaUsuarios = async () => {
  try {
    return COLUMNS_CONSULTA_USUARIOS;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas da consulta de usuarios.'
    );
    return null;
  }
};

const getFiltersConsultaUsuarios = async () => {
  try {
    return FILTRO_CONSULTA_USUARIOS;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os filtros da consulta de usuarios.'
    );
    return null;
  }
};

const getListConsultaUsuarios = async (values) => {
  try {
    if (!values) {
      return [];
    }

    const client = await api('mesaveic');
    const { data } = await client.get(`/gestaoAcessos/consultarUsuarios`, {
      params: values,
    });

    if (data) {
      return data;
    }
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os resultados da busca de perfis.'
    );
    return [];
  }
};

const getFieldsCadastroUsuario = async () => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get('/gestaoAcessos/listarPerfis');

    FIELDS_CADASTRO_USUARIO[4].options = data;

    return FIELDS_CADASTRO_USUARIO;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas do cadastro de usuarios.'
    );
    return null;
  }
};

const getFieldsEditarUsuario = async (idUsuario) => {
  try {
    const consulta = await api('consulta');
    const { data } = await consulta.get(`usuario/${idUsuario}`);
    const mesa = await api('mesaveic');
    const perfis = await mesa.get('/gestaoAcessos/listarPerfis');

    if (data && perfis.data) {
      FIELDS_EDITAR_USUARIO[0].value = data.usuario.Nome;
      FIELDS_EDITAR_USUARIO[1].value = data.usuario.email;
      FIELDS_EDITAR_USUARIO[2].value = data.usuario.CpfCnpj.toString() || '';
      FIELDS_EDITAR_USUARIO[3].value = data.usuario.Telefone;
      FIELDS_EDITAR_USUARIO[4].options = perfis.data;
      FIELDS_EDITAR_USUARIO[4].value = data.perfis;
      FIELDS_EDITAR_USUARIO[5].value = data.usuario.Funcional;
      FIELDS_EDITAR_USUARIO[5].disabled = false;
      FIELDS_EDITAR_USUARIO[6].value = data.usuario.Status;
      FIELDS_EDITAR_USUARIO[6].disabled = true;
      return FIELDS_EDITAR_USUARIO;
    }

    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas da edição de usuarios.'
    );
    return [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas do cadastro de usuarios.'
    );
    return null;
  }
};

const cadastroUsuario = async (values) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/gestaoAcessos/salvarUsuario', values);

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro inserir dados do usuário.');
    return null;
  }
};

const getColumnsRelatorioUsuarios = async (tipoRelatorio) => {
  try {
    if (tipoRelatorio === 'Gestao') return COLUMNS_RELATORIO_USUARIOS_GESTAO;

    return COLUMNS_RELATORIO_USUARIOS_BLOQUEIO;
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar as colunas da Relatorio de usuarios.'
    );
    return null;
  }
};

const getFiltersRelatorioUsuarios = async () => {
  try {
    const consulta = await api('consulta');
    const { data } = await consulta.get('/relatorioUsuario/formulario');
    return data ? data.obj : [];
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os filtros de Relatorio de usuarios.'
    );
    return null;
  }
};

const getListRelatorioUsuarios = async (values) => {
  try {
    const client = await api('consulta');
    const { data } = await client.post(`/relatorioUsuario/consulta`, values);
    if (data) {
      return data;
    } else {
      return [];
    }
  } catch (error) {
    toast.error(
      'Ocorreu um erro ao tentar carregar os resultados da busca de perfis.'
    );
    return [];
  }
};

const exportRelatorioUsuarioExcel = async (values, type) => {
  try {
    const client = await api('consulta');
    const { data } = await client.post(
      `/usuario/exportarExcel?type=${type}`,
      values,
      { responseType: 'arraybuffer' }
    );
    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar exportar o arquivo Excel.');
    return null;
  }
};

const exportRelatorioUsuarioPDF = async (values) => {
  try {
    const client = await api('consulta');
    const { data } = await client.post(`/usuario/exportarPDF`, values, {
      responseType: 'arraybuffer',
    });
    return data ? data : [];
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar exportar o arquivo PDF.');
    return null;
  }
};

const bloqueio = async (row) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/usuario/bloquearDesbloquear', {
      idUsuario: row.IdUsuario.toString(),
    });
    data === 0
      ? toast.success('Usuário Desbloqueado')
      : toast.success('Usuário Bloqueado');
    return data;
  } catch (error) {
    toast.error('Não foi possível realizar bloqueio/desbloqueio');
    return [];
  }
};

const desativaUsuario = async (row) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.put('/usuario/ativarDesativar', {
      idUsuario: row.IdUsuario.toString(),
    });
    toast.success(data);
    return data;
  } catch (error) {
    toast.error('Não foi possível realizar bloqueio/desbloqueio');
    return [];
  }
};

const reenvioPrimeiroAcesso = async (row) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.get('/gestaoAcessos/primeiroAcesso', {
      params: { idUsuario: row.IdUsuario.toString() },
    });
    toast.success(data.msg);
    return data;
  } catch (error) {
    toast.error('Não foi possível realizar o reenvio do primeiro acesso');
    return [];
  }
};

const uploadGestaoEmMassa = async (files) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post(`/gestaoEmMassa`, { files });

    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os arquivos.');
    return null;
  }
};

const desativarPerfil = async ({ IdGrupo, Descricao }) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/perfis/excluir/', {
      IdGrupo: IdGrupo,
      Descricao: Descricao,
    });
    toast.success(data);
    return data;
  } catch (error) {
    toast.error('Não foi possível excluir perfil');
    return [];
  }
};

const logConsultaPerfil = async ({ IdGrupo, Descricao }) => {
  try {
    const client = await api('mesaveic');
    const { data } = await client.post('/perfis/logConsulta/', {
      IdGrupo: IdGrupo,
      Descricao: Descricao,
    });

    return data;
  } catch (error) {
    return null;
  }
};

const sendEmailPwd = async ({ login, tokens: { corporate } }) => {
  try {
    const client = await api('corporate')
    const { data } = await client.post('/esquecipwd', {
      login: login,
      validarCpf: false
    })

    if(data.errors) {
      return {
        msg: 'Error ao enviar e-mail.',
        success: false
      }
    }
    return {
      msg: 'E-mail enviado com sucesso! Verifique também sua caixa de spam.',
      success: true
    }
  } catch (error) {
    return null
  }
}


export {
  getColumnsConsultaPerfil,
  getFiltersConsultaPerfil,
  getListConsultaPerfis,
  getColumnsConsultaUsuarios,
  getFiltersConsultaUsuarios,
  getListConsultaUsuarios,
  getFieldsCadastroUsuario,
  cadastroUsuario,
  getLogUsuario,
  getColumnsRelatorioUsuarios,
  getFiltersRelatorioUsuarios,
  getListRelatorioUsuarios,
  getPermissoesMenu,
  getPermissoesFuncionalidades,
  salvarPermissoes,
  bloqueio,
  desativaUsuario,
  reenvioPrimeiroAcesso,
  exportRelatorioUsuarioExcel,
  exportRelatorioUsuarioPDF,
  getFieldsEditarUsuario,
  desativarPerfil,
  logConsultaPerfil,
  sendEmailPwd
};
